"use client";
import { cn as e } from "../../design/cn.js";
import { TableProvider as t, useTableContextSafe as n } from "./table-context.js";
import { isValidElement as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
// src/components/data-table/DataTableCard.tsx
var o = ({ children: n, className: r, size: a = "md", ...o }) => /* @__PURE__ */ i(t, {
	value: {
		size: a,
		variant: "default"
	},
	children: /* @__PURE__ */ i("div", {
		...o,
		className: e(r),
		children: n
	})
});
o.displayName = "TableCardRoot";
var s = ({ title: t, badge: o, description: s, contentTrailing: c, className: l }) => {
	let { size: u } = n();
	return /* @__PURE__ */ a("div", {
		className: e("relative flex flex-col items-start gap-4 rounded-t-md border border-border bg-card backdrop-blur-sm px-4 md:flex-row", u === "sm" ? "py-4 md:px-5" : "py-5 md:px-6", l),
		children: [/* @__PURE__ */ a("div", {
			className: "flex flex-1 flex-col gap-0.5",
			children: [/* @__PURE__ */ a("div", {
				className: "flex items-center gap-2",
				children: [/* @__PURE__ */ i("h2", {
					className: e("font-semibold text-foreground", u === "sm" ? "text-sm" : "text-md"),
					children: t
				}), o ? r(o) ? o : /* @__PURE__ */ i("span", {
					className: "inline-flex items-center rounded-full bg-primary/10 px-2 py-1 text-xs font-medium text-primary ring-1 ring-inset ring-primary/30",
					children: o
				}) : null]
			}), s && /* @__PURE__ */ i("p", {
				className: "text-xs text-muted-foreground",
				children: s
			})]
		}), c]
	});
};
s.displayName = "TableCardHeader";
var c = {
	Root: o,
	Header: s
};
export { c as TableCard, s as TableCardHeader, o as TableCardRoot };

//# sourceMappingURL=DataTableCard.js.map